import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-input-text-phone',
  templateUrl: './st-input-text-phone.component.html',
  styleUrls: ['./st-input-text-phone.component.scss'],
  standalone: false
})
export class StInputTextPhoneComponent {

  @Input()
  label = 'FIELD LABEL';

  @Input()
  idVal: string = 'phoneTextId';

  @Input()
  inputVal: string = '';

  @Input()
  placeHolderVal = 'Phone Number';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000';

  @Input()
  requiredVal: boolean = false;
  @Input()
  maxLength: number = 20;

  @Output()
  onClick = new EventEmitter<Event>();
}
